import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4d34e4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]


import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { EffectCoverflow, Navigation } from "swiper";
import { getImageUrl } from '@/utils/FileUtils'



export default /*#__PURE__*/_defineComponent({
  __name: 'ImageCarousel',
  props: {
    images: null
  },
  setup(__props: any) {

const props = __props as {
    images: string[]
}



const modules = [EffectCoverflow, Navigation]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Swiper), {
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: "auto",
    coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
        },
    navigation: true,
    modules: modules,
    class: "mySwiper"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (image) => {
        return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: image }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(getImageUrl)(image),
              alt: ""
            }, null, 8, _hoisted_1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})